import axios, { AxiosResponse } from 'axios';

import { getAuthHeaders } from '@/lib/httpsAgent';

import { OptionsWithServerSideRequest } from '@/models/api';
import { LoginResponse } from '@/models/api/Login';
import { EnvironmentService } from '@/services/EnvironmentService';

async function login(
    username: string,
    password: string,
    j_transparent: boolean = false
): Promise<AxiosResponse<LoginResponse, unknown>> {
    const url = `${EnvironmentService.getPublicBaseURL()}/login_post.htm?j_json=true`;
    const params = new URLSearchParams();

    params.set('j_username', username);
    params.set('j_password', password);
    params.set('j_transparent', j_transparent.toString());

    return axios.post<LoginResponse>(url, params).then((data) => data);
}

function logout(opts?: OptionsWithServerSideRequest): Promise<AxiosResponse<unknown>> {
    const url = new URL(`${EnvironmentService.getPublicBaseURL()}/account/logout`);
    const headers = getAuthHeaders(opts);

    return axios.get(url.toString(), {
        headers
    });
}

export const AuthService = {
    login,
    logout
};
